import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseService } from '@tcc-mono/shared/data-access';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { Collection } from '@tcc-mono/classifact/shared/data-access/models';
import { catchError,throwError,Observable,of } from 'rxjs';

export interface CollectionUsage {
  collection: Collection;
  studies: Array<{
    id: string;
    name: string;
    specs: number;
    questions: number;
  }>;
  games: Array<{
    id: string;
    name: string;
    sessions: number;
  }>;
}

@Injectable({
  providedIn: 'root'
})
export class CollectionService extends BaseService<Collection> {

  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = '/api/collections';
  }

  getById(id: string): Observable<Collection | null> {
    return this._http.get<Collection>(this.getUrl(`${this.path}/${id}`)).pipe(
      catchError((err) => {
        if (err.status === 404) {
          return of(null); // ✅ Geen foutmelding, gewoon null teruggeven
        }
        return throwError(() => err); // ❌ Andere fouten gooi je door
      })
    );
  }

  getUsage(id: string): Observable<CollectionUsage> {
    return this._http.get<CollectionUsage>(this.getUrl(`${this.path}/${id}/usage`)).pipe(
      catchError((err) => {
        if (err.status === 404) {
          return of({
            collection: null,
            studies: [],
            games: []
          } as CollectionUsage);
        }
        return throwError(() => err);
      })
    );
  }
  
}
